<div class="container">
  <section class="container__info">
    <h1 class="home__title">
      Impulsione seu negócio com soluções financeiras sob medida
    </h1>
    <div class="container__info--width">
      <div class="container-info--text">
        <p class="home__subtitle">
          Descubra como a Broadfactor pode ajudar você a prosperar, simplificar
          sua gestão e crescer com segurança.
        </p>
      </div>
      <img
        src="../../../assets/img/png/antecipação-de-recebíveis 1.png"
        alt=""
      />
    </div>
  </section>

  <section class="container-benefits">
    <div class="container-benefits__box">
      <h1>Soluções que conectam e transformam</h1>
    </div>
    <div class="container-benefits__width">
      <div class="container-benefits__grid">
        <p class="home__subtitle">
          Na Broadfactor entendemos as necessidades únicas de cada empreendedor.
          Oferecemos soluções inovadoras que conectam empresas, investidores e
          gestores de forma eficiente.
        </p>
        <img src="../../../assets/img/png/imagen emp.png" alt="" />
      </div>
    </div>
  </section>

  <section class="container__home">
    <div class="title-container">
      <h2 class="home__title">Nossas categorias de serviços</h2>
      <p class="home__subtitle">
        Descubra como nossas categorias de serviços podem atender às suas
        necessidades!
      </p>
    </div>
  </section>

  <section class="container-requirements">
    <div class="company-requirements">
      <img src="../../../assets/img/png/und1.png" alt="" />
      <div class="requirement-container">
        <h2>Antecipar recebíveis</h2>
        <p class="home__subtitle">
          Empresas podem antecipar recebíveis de forma segura e rápida, obtendo
          liquidez imediata para investir no crescimento, proporcionando melhor
          fluxo de caixa.
        </p>
        <div class="actions-container">
          <button mat-flat-button (click)="openRegister()" color="primary">
            Antecipar Duplicatas
          </button>
          <button
            mat-flat-button
            class="style-button"
            (click)="
              redirect(
                'https://plataforma.antecipagov.com.br/cadastro/fornecedor'
              )
            "
          >
            Antecipar contratos do governo
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="container-requirements">
    <div class="company-requirements">
      <img src="../../../assets/img/png/und2.png" alt="" />
      <div class="requirement-container">
        <h2>Financiadores - Parceiros</h2>
        <p class="home__subtitle">
          Financiadores podem antecipar recebíveis de empresas privadas que
          vendem à prazo para outras empresas ou governos.
        </p>
        <div class="actions-container">
          <button
            mat-flat-button
            (click)="redirect('https://register.broadfactor.com/comprador')"
            color="primary"
          >
            Recebíveis privados
          </button>
          <button
            mat-flat-button
            class="style-button"
            (click)="
              redirect(
                'https://plataforma.antecipagov.com.br/cadastro/financiador'
              )
            "
            color="primary"
          >
            Recebíveis governo
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="container-requirements">
    <div class="company-requirements">
      <img src="../../../assets/img/png/und3.png" alt="" />
      <div class="requirement-container">
        <h2>Conta Digital</h2>
        <p class="home__subtitle">
          Empreendedores e gestores podem contar com nossa conta digital para
          pagamentos, recebimentos, operações de crédito com agilidade,
          simplicidade e segurança.
        </p>
        <div class="actions-container">
          <button
            class="account-pj-button"
            mat-flat-button
            (click)="redirect('https://broadfactorpay.com/register')"
          >
            Abra sua conta PJ
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
